import { Component, Input } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { RowmenuComponent } from '../rowmenu/rowmenu.component';
import { CrossmatchService } from '../../../services/crossmatch.service';
import { NotifyService } from '../../../common/notify/notify.service';
import { CrossmatchType } from '../add-crossmatch/add-crossmatch.component';
import { Crossmatch } from '../../../interfaces/crossmatch';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-crossmatch-list',
    imports: [MatListModule, RowmenuComponent, CommonModule],
    templateUrl: './crossmatch-list.component.html',
    providers: [NotifyService],
    styleUrl: './crossmatch-list.component.scss'
})
export class CrossmatchListComponent {
  @Input() crossmatches?: Crossmatch[];
  @Input() totalRows?: number;
  @Input() highlightText?: string;
  @Input() type?: CrossmatchType;

  selectedCrossmatch?: Crossmatch;

  constructor(
    private readonly crossmatchService: CrossmatchService,
    private readonly notify: NotifyService
  ) {}

  // No ngOnInit needed - component receives filtered data from parent via @Input()
  key(_index: number, crossmatch: Crossmatch) {
    return this.type + '-' + crossmatch.id;
  }

  async handleAction(action: { event: string; param: Crossmatch }) {
    const comb = action.param;

    if (action.event === 'delete' && comb.id) {
      this.crossmatchService.deleteCrossmatch(comb.id).subscribe({
        next: (response) => {
          console.log('Crossmatch deleted:', response);
          this.notify.withAutodismiss(`Deleted ${this.type} Crossmatch [${comb.recipientEnis}, ${comb.donorEnis}]`);
          if (this.type === 'Negative') {
            this.crossmatchService.removeNegativeCrossmatch(comb.id);
          } else if (this.type === 'Positive') {
            this.crossmatchService.removePositiveCrossmatch(comb.id);
          }
        },
        error: (err) => {
          this.notify.withAutodismiss(`Couldn't delete ${this.type} Crossmatch [${comb.recipientEnis}, ${comb.donorEnis}] ${err}`);
        }
      });
    }
  }

  showCrossmatchDetails(crossmatch: Crossmatch): void {
    if (this.selectedCrossmatch && this.selectedCrossmatch.id === crossmatch.id) {
      this.selectedCrossmatch = undefined;
    } else {
      this.selectedCrossmatch = crossmatch;
    }
  }

  closeCrossmatchDetails(): void {
    this.selectedCrossmatch = undefined;
  }
}
